/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';

import COLORS from '$variables/colors';
import { spacing, typography } from '$variables/theme';

const customMuiTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: COLORS.border1,
      },
      '&:hover fieldset': {
        borderColor: COLORS.border1,
      },
      '&.Mui-focused fieldset': {
        borderColor: COLORS.green,
        border: '1px solid',
      },
      '&.Mui-error': {
        fieldset: {
          borderColor: COLORS.errorRed,
        },
        '&:hover fieldset': {
          borderColor: COLORS.errorRed,
        },
        '&.Mui-focused fieldset': {
          border: `2px solid ${COLORS.errorRed}`,
        },
      },
      '& input': {
        fontSize: 14,
        fontWeight: typography.fontWeightBold,
        lineHeight: spacing.xLarge,
        paddingLeft: spacing.small,
        paddingTop: spacing.small,
        paddingBottom: spacing.small,
        '& .MuiOutlinedInput-adornedEnd': {
          paddingRight: 0,
        },
      },
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: spacing.small,
    },
    '& .MuiTypography-root': {
      fontSize: 14,
    },
  },
})(MuiTextField);

export const TextField = styled(customMuiTextField, {
  shouldForwardProp: (prop) => !['inputAdornment'].includes(prop),
})`
  height: 38px;
  margin-top: 0;
  margin-bottom: 0;
  width: ${({ width }) => `${width}px`};
  min-width: ${({ width }) => `${width}px`};
`;
